<template>
  <span>
    <span v-if="donePreparation">
      <span v-if="notes" class="prep js-tooltip" :data-title="`Preparato: ${notes}`">
        <i class="fa-light fa-note-sticky"></i>
      </span>
    </span>
    <span v-else>
      <span v-if="notes" class="np_badge label label-important js-tooltip" :data-title="`Non preparato: ${notes}`">
        NP <i class="fa-light fa-note-sticky-o"></i>
      </span>
      <span v-else class="np_badge label label-important js-tooltip"> NP </span>
    </span>
  </span>
</template>
<script>
export default {
  name: 'npLabel',
  props: ['notes', 'donePreparation'],
  mounted() {
    window.BTTooltip.tooltipInit($('.prep.js-tooltip'));
    window.BTTooltip.tooltipInit($('.np_badge.js-tooltip'));
  },
};
</script>
